import React from 'react';
import { ArrowRightIcon, SparklesIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://checkout.recursostop.shop/cart/45770493690052:1';
const STEPS = [{
  icon: '📂',
  text: 'Abrís el material',
  desc: 'Acceso inmediato al contenido digital'
}, {
  icon: '🌿',
  text: 'Comprendés la energía',
  desc: 'Teoría clara sin complicaciones'
}, {
  icon: '👐',
  text: 'Practicás con claridad',
  desc: 'Ejercicios guiados paso a paso'
}, {
  icon: '💫',
  text: 'Integrás Reiki a tu vida',
  desc: 'Transformación real y duradera'
}];
export function SolutionSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [ref3, vis3] = useReveal();
  return <section className="bg-[#2d1f3d] text-white py-24 md:py-32 px-4 relative overflow-hidden" data-id="element-241">
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-242"></div>

      <div className="container mx-auto max-w-5xl text-center relative z-10" data-id="element-243">
        <div ref={ref1} className={`reveal mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-244">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 text-sm font-medium mb-6" data-id="element-245">
            <SparklesIcon className="w-4 h-4" data-id="element-246" /> El Camino del Reiki
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-247">
            MegaPack Reiki
            <br className="hidden md:block" data-id="element-248" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200" data-id="element-249">
              Formación Completa
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 mb-0 leading-relaxed max-w-2xl mx-auto" data-id="element-250">
            Un sistema paso a paso para que cualquier persona pueda iniciarse en
            Reiki con seguridad, integrar la energía a su vida y avanzar con
            confianza.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-4 gap-6 mb-20 relative ${vis2 ? 'is-visible' : ''}`} data-id="element-251">
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-amber-500/30 to-transparent -z-10" data-id="element-252"></div>
          {STEPS.map((step, idx) => <div key={idx} className="group relative bg-gray-800/40 backdrop-blur-sm border border-white/5 hover:border-amber-500/30 rounded-3xl p-6 text-center transition-all duration-300 hover:-translate-y-1" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-253">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 text-6xl font-bold text-white/5 select-none pointer-events-none font-serif" data-id="element-254">
                0{idx + 1}
              </div>
              <div className="w-16 h-16 mx-auto bg-gray-800 rounded-2xl flex items-center justify-center text-3xl mb-4 shadow-lg group-hover:shadow-amber-500/20 group-hover:scale-110 transition-all duration-300 border border-white/10" data-id="element-255">
                {step.icon}
              </div>
              <h3 className="font-serif font-bold text-white text-lg mb-2 group-hover:text-amber-400 transition-colors" data-id="element-256">
                {step.text}
              </h3>
              <p className="text-sm text-gray-500 leading-snug" data-id="element-257">{step.desc}</p>
            </div>)}
        </div>

        <div ref={ref3} className={`reveal bg-gradient-to-b from-gray-800/50 to-transparent p-8 rounded-3xl border border-white/5 max-w-3xl mx-auto ${vis3 ? 'is-visible' : ''}`} data-id="element-258">
          <p className="text-xl md:text-2xl font-bold text-amber-100 mb-8 font-serif" data-id="element-259">
            "Sin improvisar. Sin dudas. Sin confusión."
          </p>
          <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="cta-btn inline-flex items-center gap-2 px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-260">
            👉 QUIERO EMPEZAR AHORA
            <ArrowRightIcon className="w-5 h-5" data-id="element-261" />
          </a>
        </div>
      </div>
    </section>;
}